import mixx from '../../../../mixin/mixin.js'

export default {
  mixins: [mixx],
  data () {
    return {
      loading: false,
      loading_f: false,
      tbv: null,
      ventast_tabla: 0,
      f_c: {
        desde: this.date_rest(this.currentdate(), -7),
        hasta: this.currentdate(),
        detalle: ''
      },
      datos: []

    }
  },

  mounted: function () {
    $('.box').boxWidget()
    this.consultar()
  },

  methods: {
    copiarLink (val) {
      navigator.clipboard.writeText(val)
      this.showNotification({
        msj: 'Link copiado.',
        bg: 'bg-green'
      })
    },

    estado_color (val) {
      let st = ''
      switch (val) {
        case 'APROBADO':
          st = 'bg-green'
          break
        case 'NEGADO':
          st = 'bg-red'
          break
        case 'EN PROCESO':
          st = 'bg-aqua'
          break

        case 'VENCIDO':
          st = 'bg-gray'
          break
      }
      return st
    },
    consultar () {
      this.loading = true
      this.$http
        .post('/SERVER/scd/ecash/', {
          'a': 'lista',
          'f': this.f_c
        }, {
          withCredentials: true
        })
        .then(response => {
          if (response.data.status === 1) {
            this.datos = response.data.data
          } else if (response.data.status === 413) {
            this.showNotification({
              msj: 'El rango de fechas es superior a 30 días',
              bg: 'bg-red'
            })
          } else {
            this.showNotification({
              msj: 'No se recuperaron datos.',
              bg: 'bg-yellow'
            })
          }
          this.loading = false
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/ecash/linksPago/tventas/tventas.js